import { SalesTaxFilingStatusEnum } from '@prisma/client';

import { IIndirectTaxFilingsV2ListParams } from './types';
import { useIndirectTaxFilingsV2 } from './useIndirectTaxFilingsV2';

type StatusCountParams = Omit<
  IIndirectTaxFilingsV2ListParams,
  'filingStatuses' | 'cursor' | 'limit'
>;

// Fires one count-only list request for a single status. The caller pins
// `filingStatuses` so the status tab itself never invalidates these queries —
// counts only refresh when non-status filters change.
export function useIndirectTaxFilingV2StatusCount(
  status: SalesTaxFilingStatusEnum,
  params: StatusCountParams | null
): { count: number; isLoading: boolean; error: unknown } {
  const { count, isLoading, error } = useIndirectTaxFilingsV2(
    params
      ? {
          ...params,
          limit: 1,
          filingStatuses: [status],
        }
      : null
  );
  return { count, isLoading, error };
}
